import { lazy } from "react";

const LazyCreateEditTask = lazy(() => import("./CreateEditTask"));

const CreateEditTask = (props: { mode: "create" | "edit" }) => (
  <LazyCreateEditTask {...props} />
);

export default CreateEditTask;
